var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKuWah(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.76 0.460024L20.76 5.92003C20.76 7.96003 20.4 9.84003 19.68 11.56C18.96 13.28 17.74 15.02 16.02 16.78L12.9 14.32C14.18 13 15.08 11.78 15.6 10.66C16.12 9.54003 16.38 8.34003 16.38 7.06003L18.24 8.80003H12.36V0.460024H20.76ZM8.82001 0.460024V5.92003C8.82001 7.96003 8.46001 9.84003 7.74001 11.56C7.02001 13.28 5.80001 15.02 4.08001 16.78L0.960009 14.32C2.24001 13 3.14001 11.78 3.66001 10.66C4.18001 9.54003 4.44001 8.34003 4.44001 7.06003L6.30001 8.80003L0.42001 8.80003L0.42001 0.460024L8.82001 0.460024Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuWah);
export default __webpack_public_path__ + "static/media/KuWah.480e7be86e17de63e42fd2e60232157b.svg";
export { ForwardRef as ReactComponent };